export function extractEmailFromUserString(
  value: string | null | undefined,
): { name: string; email: string } | null {
  if (value === null) return value;

  if (!value || typeof value !== 'string') return { name: '', email: '' };

  const words = value.split(' ');

  const email = words.pop() ?? '';

  const name = words.join(' ');

  return { name, email };
}
